import { render } from "react-dom";
import { StrictMode } from "react";
import App from "./App";
import { Provider } from "react-redux";
import { store } from "utils/store";

render(
  <StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </StrictMode>,
  document.getElementById("root")
);
